import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    migas: [
      {
        text: 'Mis Docs',
        to: {name: 'docs'}
      }
    ],
    carpetas: [], //[{gestion: '1997', id: '1997'}],
    mostrar_form_colegio: false,
    colegios: [], //[{distrito: 'Cercado 1', nombre: 'San Agustin', turno: 'Maniana', gestion: '1997', id: 1}],
    mostrar_form_curso: false,
    cursos: [],
    /*  {grado: 1, nombre: 'Primero A', colegio: 1, id: 1},
      {grado: 1, nombre: 'Primero B', colegio: 1, id: 2}
    ],*/
    planilla: [],
    token: localStorage.getItem('user-token') || '',
    user: localStorage.getItem('user-name') || 'Usuario'
  },
  getters: {
    estaAutenticado: state => !!state.user,
    estaNivel1: state => state.migas.length >= 1,
    estaNivel2: state => state.migas.length >= 2,
    estaNivel3: state => state.migas.length >= 3
  },
  mutations: {
    agregarMiga(state, miga) {
      let idx = state.migas.findIndex(item => item.text === miga.text)
      //console.log('Longitud:',idx)
      if (idx > -1) state.migas.splice(idx)
      state.migas.push(miga)
      let len = state.migas.length -1
      //console.log('Longitud:',len)
      switch (len) {
        case 1:
          //console.log('Gestion...', miga.to.params.gestion)
          let carp = state.carpetas.find(item => item.id === miga.to.params.gestion)
          state.planilla.splice(0)
          state.planilla.push(carp)
          break
        case 2:
          //console.log('Colegio...', miga.to.params.colegio)
          let cole = state.colegios.find(item => item._id === miga.to.params.colegio)
          state.planilla.splice(1)
          state.planilla.push(cole)
          break
        case 3:
          //console.log('Curso...', miga.to.params.curso)
          let curs = state.cursos.find(item => item._id === miga.to.params.curso)
          state.planilla.splice(2)
          state.planilla.push(curs)
      }
      console.log(state.planilla)
    },
    agregarCarpeta(state, carpeta) {
      state.carpetas.push(carpeta)
    },
    mostrarFormColegio(state, valor) {
      state.mostrar_form_colegio = valor
    },
    reiniciarColegios(state) {
      state.colegios.splice(0)
    },
    agregarColegio(state, colegio) {
      //console.log('Colegio agregado...', colegio)
      state.colegios.push(colegio)
    },
    actualizarColegio(state, colegio) {
      let idx = state.colegios.findIndex(item => item._id === colegio._id)
      let txt = state.colegios[idx].nombre
      //console.log('Nombre anterior colegio...', txt)
      state.colegios.splice(idx, 1, colegio)
      idx = state.migas.findIndex(item => item.text === txt)
      //console.log('Indice en migas...', idx)
      let miga = state.migas[idx]
      //console.log('Miga...', miga)
      miga.text = colegio.nombre
      state.migas.splice(idx, 1, miga)
    },
    mostrarFormCurso(state, valor) {
      state.mostrar_form_curso = valor
    },
    reiniciarCursos(state) {
      state.cursos.splice(0)
    },
    agregarCurso(state, curso) {
      //console.log('Curso agregado...', curso)
      state.cursos.push(curso)
    },
    actualizarCurso(state, curso) {
      let idx = state.cursos.findIndex(item => item._id === curso._id)
      let txt = state.cursos[idx].nombre
      state.cursos.splice(idx, 1, curso)
      idx = state.migas.findIndex(item => item.text === txt)
      let miga = state.migas[idx]
      miga.text = curso.nombre
      state.migas.splice(idx, 1, miga)
      state.planilla.splice(2, 1, curso)
    },
    registrarToken(state, token) {
      state.token = token
      localStorage.setItem('user-token', token)
    },
    registrarUser(state, user) {
      state.user = user
      state.token = user
      localStorage.setItem('user-name', user)
    },
    removerUser(state) {
      state.token = ''
      localStorage.removeItem('user-token')
      state.user = 'Usuario'
      localStorage.removeItem('user-name')
    }
  },
  actions: {
    logoutUser({commit}) {
      commit('removerUser')
    }
  },
  modules: {
  }
})
